import './App.css';
import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import SchoolTransformation from './pages/SchoolTransformation';
import DigitalTLM from './pages/DigitalTLM';
import SmartECCE from './pages/SmartECCE';
import VillageSchools, { RemoteClassrooms } from './pages/VillageAndRemote';
import NetRakshak from './pages/NetRakshak';
import { Technology, Research, About } from './pages/OtherPages';
import ProjectsListing from './pages/projects/ProjectsListing';
import { WcddHaryana, SatnavariDigitalAnganwadi } from './pages/projects/ProjectDetail';
import ProjectVideos from './pages/projects/ProjectVideos';
import TechDetail from './pages/TechDetail';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import { Toaster } from './components/ui/toaster';
import { api } from './lib/api';
import { applyContent } from './mock';

function App() {
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    api.get('/content')
      .then(({ data }) => applyContent(data))
      .catch(() => {})
      .finally(() => setBooted(true));
  }, []);

  if (!booted) return <div className="min-h-screen bg-[var(--mm-cream)]" data-testid="app-booting" />;

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/transform/school" element={<SchoolTransformation />} />
          <Route path="/transform/digital-tlm" element={<DigitalTLM />} />
          <Route path="/transform/smart-ecce" element={<SmartECCE />} />
          <Route path="/transform/village-schools" element={<VillageSchools />} />
          <Route path="/transform/remote-classrooms" element={<RemoteClassrooms />} />
          <Route path="/transform" element={<SchoolTransformation />} />
          <Route path="/netrakshak" element={<NetRakshak />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/technology/:slug" element={<TechDetail />} />
          <Route path="/projects" element={<ProjectsListing />} />
          <Route path="/projects/wcdd-haryana" element={<WcddHaryana />} />
          <Route path="/projects/satnavari-digital-anganwadi" element={<SatnavariDigitalAnganwadi />} />
          <Route path="/projects/videos" element={<ProjectVideos />} />
          <Route path="/research" element={<Research />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
